import styled from 'styled-components';
import academyStyles from './academy-styles';

export default function AcademyIconSvgResource(props) {
  const defaultWidth = 16;
  const defaultHeight = 16;

  const height = props.height || defaultHeight;
  const calculatedWidth = (defaultWidth / defaultHeight) * height;

  return (
    <AcademyIconWrapper width={calculatedWidth} height={height} role="none">
      <canvas width={calculatedWidth} height={height} />
      <svg width={calculatedWidth} height={height} viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.5">
          <g transform="translate(-576.000000, -2480.000000)">
            <g transform="translate(550.000000, 2262.000000)">
              <g transform="translate(24.000000, 216.000000)">
                <path
                  d="M18,2 L18,13 L13,18 L2,18 L2,2 L18,2 Z M17,3 L3,3 L3,17 L12,17 L12,12 L17,12 L17,3 Z M16.585,13 L13,13 L13,16.585 L16.585,13 Z M10,12 L10,13 L6,13 L6,12 L10,12 Z M14,9 L14,10 L6,10 L6,9 L14,9 Z M14,6 L14,7 L6,7 L6,6 L14,6 Z"
                  fill={props.color || academyStyles.common.contentTypeIconColor}
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </AcademyIconWrapper>
  );
}

const AcademyIconWrapper = styled.div`
  display: inline-block;
  position: relative;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  canvas {
    visibility: hidden;
  }
  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
  }
`;
